import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query EligibleForDailyCheckIn($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        eligibleForDailyCheckIn
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.EligibleForDailyCheckInQuery,
    boolean | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select('eligibleForDailyCheckIn', PASS_THROUGH),
    ),
  ),
  false,
)

export const executor = graphql.createExecutor<
  graphql.schema.EligibleForDailyCheckInQuery,
  boolean,
  graphql.schema.EligibleForDailyCheckInQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
